import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const JobCategoryDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Job Category"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Job Category">
                {getFieldDecorator('jobCategory', {
                 initialValue: data.jobCategory,
                  rules: [{ required: true, message: 'Please input the Job Category!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default JobCategoryDialogForm;
